import AccountApi from '@/api/account'

class AgcForm {
  constructor({ id, name, permission, belong }) {
    this.id = id
    this.name = name
    this.permission = permission
    this.belong = belong
    this.advertisers = []
  }
}

class AdvForm {
  constructor({ id, name, permission, belong }) {
    this.id = id
    this.name = name
    this.belong = belong
    this.permission = permission
    this.insertionOrders = []
  }
}

class IoForm {
  constructor({ id, name, permission }) {
    this.id = id
    this.name = name
    this.permission = permission
  }
}

class RequestBuilder {
  //
  static build(authChainModel, agcIsInherit) {
    // 代理店が inherit であり、
    // 一度もいじられていない場合は 代理店のpermissionをinheritになおしてから送る
    if (agcIsInherit === true && authChainModel.isChanged === false) {
      authChainModel.permission = 'inherit'
    }
    const agcForm = new AgcForm(authChainModel)

    authChainModel.advertiserAuths.forEach((adv, index, advs) => {
      const advForm = new AdvForm(adv)

      if (adv.insertionOrderAuths !== undefined) {
        adv.insertionOrderAuths.forEach((io, index, ios) => {
          const ioForm = new IoForm(io)
          advForm.insertionOrders.push(ioForm)
        })
      }

      agcForm.advertisers.push(advForm)
    })
    return agcForm
  }
}

const actions = {
  async GET({ commit }, { agencyId, accountId, userType }) {
    commit('SET_CURRENT_EDITING_USER_TYPE', { userType })
    // 代理店がinheritかどうかを初期化
    // 代理店がinheritかどうかは、リクエストオブジェクトを作成する際に使用する
    const isInherit = false
    commit('SET_AGENCY_INHERIT', { isInherit })
    const data = await AccountApi.getAgencyAccountAuth(agencyId, accountId)
    const rawAuthChain = data.item
    if (rawAuthChain.permission === 'inherit') {
      const isInherit = true
      commit('SET_AGENCY_INHERIT', { isInherit })
    }
    commit('INITIALIZE', { rawAuthChain, userType })
  },
  ON_PARENT_PERMISSION_CHANGE({ commit }, { permission }) {
    commit('SET_PARENT_PERMISSION', { permission })
  },
  ON_CHILD_PERMISSION_CHANGE({ commit }, { id, permission }) {
    commit('SET_CHILD_PERMISSION', { id, permission })
  },
  ON_GRANDCHILD_PERMISSION_CHANGE({ commit }, { id, parentId, permission }) {
    commit('SET_GRONDCHILD_PERMISSION', { id, parentId, permission })
  },
  RESET({ commit }) {
    commit('RESET')
  },
  // 広告主idを指定して、その下のioをすべてinheritにする
  SET_ALL_INHERIT({ commit }, { advId }) {
    commit('SET_ALL_INHERIT', { advId })
  },
  // 代理店権限の登録
  async SAVE_AUTH_CHAIN({ commit, state }, { agencyId, accountId }) {
    const authChainModel = { ...state.currentAuthChain }
    // 代理店が初めにinheritかどうかでrequestの作り方が変わるので、渡す
    const inheritFlg = state.isInheritAgency
    const formObject = RequestBuilder.build(authChainModel, inheritFlg)
    const ret = await AccountApi.postAgencyAccountAuth(
      agencyId,
      accountId,
      formObject,
    )
    const rawAuthChain = ret.item
    const userType = state.currentEditingUserType
    commit('INITIALIZE', { rawAuthChain, userType })
  },
}

export default actions
